export const StorageKeys = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  sessionId: "sessionId",
};
